/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-19 17:15:34
 * @LastEditTime: 2020-11-19 17:19:13
 * @FilePath: \ensurance-front\src\router\modules\dictionaryMaintenance.js
 */
const DictionaryMaintenance = () => import('@/views/dictionary-maintenance/dictionary-maintenance.vue')
const SubsidyStandard = () => import('@/views/dictionary-maintenance/subsidy-standard/subsidy-standard.vue')
const TownshipStreet = () => import('@/views/dictionary-maintenance/township-street/township-street.vue')
export default [
  {
    path: '/dictionaryMaintenance',
    name: 'DictionaryMaintenance',
    component: DictionaryMaintenance,
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: '/dictionaryMaintenance/subsidy_standard',
        name: 'SubsidyStandard',
        component: SubsidyStandard,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/dictionaryMaintenance/township_street',
        name: 'TownshipStreet',
        component: TownshipStreet,
        meta: {
          keepAlive: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/dictionaryMaintenance.js